import React, { useState, createElement, useEffect, useRef } from "react";
import "./AnnotationSection.css"
// NORTON DESIGN SYSTEM
import { Button } from '@wwnds/react';
// COMPONENTS
import Annotation from "../Annotation/Annotation";
import AnnotationHeading from "../AnnotationHeading/AnnotationHeading";
import AnnotationDivider from "../AnnotationDivider/AnnotationDivider";

const AnnotationSection = ({
  Data,
  timelineIndex,
  frameIndex,
  formatTime,
  formatSectionHeaderStr,
  updateTime }) => {

  const [activeTab, setActiveTab] = useState("current")

  // handles click on tab button
  const tabClick = (value) => {
    setActiveTab(value)
  }

  const [currentAnnotationRef, setCurrentAnnotationRef] = useState()

  // AUTOSCROLL
  const annotationPaneRef = useRef(null)
  useEffect(() => {
    if (currentAnnotationRef && annotationPaneRef) {
      annotationPaneRef.current.scrollTo(
        {
          top: currentAnnotationRef.offsetTop - annotationPaneRef.current.offsetTop,
          behavior: 'smooth',
        }
      )
    }
  }, [currentAnnotationRef, annotationPaneRef])

  return (
    <section className="annotation-section">
      <div className="tab-btn-container-wrapper">
        <div className="tab-btn-container">
          <Button className={activeTab === "current" ? "active-tab" : "tab-btn"} onClick={() => tabClick("current")}
            textClass="tab-btn-txt"
          >Show Current</Button>
          <Button className={activeTab === "all" ? "active-tab" : "tab-btn"} onClick={() => tabClick("all")}
            textClass="tab-btn-txt"
          >Show All</Button>
        </div>
      </div>
      <div className="annotation-pane" ref={annotationPaneRef}>
        <div className={activeTab === "all" ? "show-annotation" : "hide-annotation"}>
          {Data.enableMod.filter(mod => mod.type === "interact")[0].interact.timelines.map((timeline, index) => (
            <div key={index}>
              <AnnotationDivider
                timeline={timeline}
                formatSectionHeaderStr={formatSectionHeaderStr}
                formatTime={formatTime}
              />
              <div
                className="annotation-div-container"
                ref={index === timelineIndex ? setCurrentAnnotationRef : null}>
                {/* <div className={index === timelineIndex ? "highlight-annotation" : "hide-highlight-annotation"}>
                  &#11044;
                </div> */}
                <div className="annotation-div">
                  {timeline.frames.map((frame, fIndex) => (
                    <div key={fIndex}>
                      <AnnotationHeading
                        timeline={timeline}
                        formatTime={formatTime}
                        formatSectionHeaderStr={formatSectionHeaderStr}
                        updateTime={updateTime}
                        timelineIndex={timelineIndex}
                        frameIndex={frameIndex}
                        Data={Data}
                        frame={frame}
                        index={index}
                        fIndex={fIndex}
                      />
                      <Annotation
                        timeline={timeline}
                        createElement={createElement}
                        annotationPaneRef={annotationPaneRef}
                        frame={frame}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={activeTab === "current" ? "show-annotation" : "hide-annotation"}>
          <div className="annotation-div-container">
            {/* <div className="highlight-annotation">&#11044;</div> */}
            <div id="current-annotation" className="annotation-div" aria-live="polite" aria-atomic>
              <AnnotationHeading
                timeline={Data.enableMod.filter(mod => mod.type === "interact")[0].interact.timelines[timelineIndex]}
                formatTime={formatTime}
                formatSectionHeaderStr={formatSectionHeaderStr}
                updateTime={updateTime}
                timelineIndex={timelineIndex}
                Data={Data}
                frame={Data.enableMod.filter(mod => mod.type === "interact")[0].interact.timelines[timelineIndex].frames[frameIndex]}
              />
              <Annotation
                timeline={Data.enableMod.filter(mod => mod.type === "interact")[0].interact.timelines[timelineIndex]}
                createElement={createElement}
                timelineIndex={timelineIndex}
                Data={Data}
                frame={Data.enableMod.filter(mod => mod.type === "interact")[0].interact.timelines[timelineIndex].frames[frameIndex]}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AnnotationSection;